(function ($) {
  function responsiveSidebarCheck() {
	var sidebar = $('ul.dynamic-sidebar');
	var quick_links = $('.quick-links-accordion');
	var dynamic_sidebar_parent = $('ul.dynamic-sidebar .parent-page');

	// checks window width for proper active state
	if ($(window).width() < 782) {
		dynamic_sidebar_parent
			.removeClass('active')
			.next('.subnav')
			.stop()
			.slideUp();
		$('.entry-content').prepend(sidebar).prepend(quick_links);
	} else {
		dynamic_sidebar_parent
			.removeClass('active')
			.next('.subnav')
			.stop()
			.slideDown();
		$('.quick-links-accordion .accordion-item')
			.removeClass('active')
			.find('.copy')
			.removeAttr('style');
		$('#dynamic-sidebar-anchor').prepend(sidebar);
		$('#quick-links-anchor').prepend(quick_links);
	}
}
$(document).ready(function () {
	if ($('ul.dynamic-sidebar').length) {
		var sidebar = $('ul.dynamic-sidebar');
		var dynamic_sidebar_parent = sidebar.find('.parent-page');

		dynamic_sidebar_parent.click(function () {
			if ($(window).width() < 782) {
				$(this).toggleClass('active');
				$(this).next('.subnav').stop().slideToggle();
			}
		});
		// plays with sidebar state
		$('li.page_item_has_children').click(function (e) {
			if (e.target !== e.currentTarget) return;
			$(this).toggleClass('active');
			$(this).find('> .children').stop().slideToggle();
		});
	}
});

$(window)
	.bind('resize', function () {
		if ($('ul.dynamic-sidebar').length > -1) {
			responsiveSidebarCheck();
		}
	})
	.trigger('resize');
}) (jQuery);